module.exports = __webpack_public_path__ + "static/img/m-index-top10-title.e6f7a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m-index-top10-title.png
// module id = 129
// module chunks = 0